import React from 'react';

export default function Footer() {
  return (
    <div id='footer' className='container-fluid bg-primary fixed-bottom'></div>
  );
}
